import axios from "axios";
import http from "Utils/api2";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const getAllTax = createAsyncThunk("getAllTax", async (url) => {
  try {
    const res = await http.get(url);
    return res.data;
  } catch (error) {
    return { data: null, success: false, message: error?.response?.data?.message };
  }
});

export const getSingleTax = createAsyncThunk("getSingleTax", async (url) => {
  try {
    const res = await http.get(url);
    return res.data;
  } catch (error) {
    return { data: null, success: false, message: error?.response?.data?.message };
  }
});

export const createTax = createAsyncThunk("createTax", async ({ url, data }) => {
  try {
    const res = await axios.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (error) {
    return {
      data: null,
      success: false,
      message: error?.response?.data?.message || "Failed to create tax",
    };
  }
});

export const updateTax = createAsyncThunk("updateTax", async ({ url, data }) => {
  try {
    const res = await axios.put(url, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (error) {
    return {
      data: null,
      success: false,
      message: error?.response?.data?.message || "Failed to update tax",
    };
  }
});

const taxSlice = createSlice({
  name: "taxSlice",
  initialState: {
    tax: null,
    singleTax: null,
    Loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllTax.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getAllTax.fulfilled, (state, action) => {
        state.Loading = false;
        state.tax = action.payload?.data;
      })
      .addCase(getAllTax.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getSingleTax.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getSingleTax.fulfilled, (state, action) => {
        state.Loading = false;
        state.singleTax = action.payload?.data;
      })
      .addCase(getSingleTax.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(createTax.pending, (state) => {
        state.Loading = true;
      })
      .addCase(createTax.fulfilled, (state) => {
        state.Loading = false;
      })
      .addCase(createTax.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(updateTax.pending, (state) => {
        state.Loading = true;
      })
      .addCase(updateTax.fulfilled, (state) => {
        state.Loading = false;
      })
      .addCase(updateTax.rejected, (state) => {
        state.Loading = false;
      });
  },
});

export default taxSlice.reducer;
